import Http from '../network/Http'

export default class HolidaysRepository {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    async getHolidays(
        startDateTime: string,
        endDateTime: string,
    ): Promise<string[]> {

        return this.http.get(`/api/holidays?start=${startDateTime}&end=${endDateTime}`)
    }
}

